(ns app.front.ui.v2.detail-row)

(defn detail-row [tr label-tr value]
  [:div.mb-4
   [:div.text-sm.font-semibold.text-ui-night-sky-100 (tr label-tr)]
   [:div.mt-1.rounded.px-3.py-2.text-sm.text-ui-night-sky-100 value]])
